"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Factory_1 = require("./Factory");

var SecurityToken_1 = require("../SecurityToken");

var PolymathError_1 = require("../../PolymathError");

var types_1 = require("../../types");

var Tokenholder_1 = require("../Tokenholder");
/**
 * Factory generates information for a Tokenholder entity
 */


var TokenholderFactory =
/*#__PURE__*/
function (_Factory_1$Factory) {
  _inherits(TokenholderFactory, _Factory_1$Factory);

  /**
   * Create an instance of the Tokenholder Factory
   */
  function TokenholderFactory(context) {
    var _this;

    _classCallCheck(this, TokenholderFactory);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TokenholderFactory).call(this, Tokenholder_1.Tokenholder, context));
    /**
     * @hidden
     */

    _this.generateProperties = function (uid) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var contractWrappers, _Tokenholder_1$Tokenh, securityTokenId, address, _SecurityToken_1$Secu, symbol, securityToken, generalTransferManager, _ref, _ref2, _ref2$, _ref2$$, canReceiveAfter, canSendAfter, expiryTime, _ref2$2, isAccredited, canNotBuyFromSTO, balance;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                contractWrappers = this.context.contractWrappers;
                _Tokenholder_1$Tokenh = Tokenholder_1.Tokenholder.unserialize(uid), securityTokenId = _Tokenholder_1$Tokenh.securityTokenId, address = _Tokenholder_1$Tokenh.address;
                _SecurityToken_1$Secu = SecurityToken_1.SecurityToken.unserialize(securityTokenId), symbol = _SecurityToken_1$Secu.symbol;
                _context.prev = 3;
                _context.next = 6;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 6:
                securityToken = _context.sent;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                _context.next = 14;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.GeneralTransferManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 14:
                generalTransferManager = _context.sent[0];
                _context.next = 17;
                return Promise.all([generalTransferManager.getKYCData({
                  investors: [address]
                }), generalTransferManager.getInvestorFlags({
                  investor: address
                }), securityToken.balanceOf({
                  owner: address
                })]);

              case 17:
                _ref = _context.sent;
                _ref2 = _slicedToArray(_ref, 3);
                _ref2$ = _slicedToArray(_ref2[0], 1);
                _ref2$$ = _ref2$[0];
                canReceiveAfter = _ref2$$.canReceiveAfter;
                canSendAfter = _ref2$$.canSendAfter;
                expiryTime = _ref2$$.expiryTime;
                _ref2$2 = _ref2[1];
                isAccredited = _ref2$2.isAccredited;
                canNotBuyFromSTO = _ref2$2.canNotBuyFromSTO;
                balance = _ref2[2];
                return _context.abrupt("return", {
                  balance: balance,
                  canSendAfter: canSendAfter,
                  canReceiveAfter: canReceiveAfter,
                  kycExpiry: expiryTime,
                  isAccredited: isAccredited,
                  canBuyFromSto: !canNotBuyFromSTO,
                  securityTokenId: securityTokenId,
                  securityTokenSymbol: symbol
                });

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));
    };

    return _this;
  }

  return TokenholderFactory;
}(Factory_1.Factory);

exports.TokenholderFactory = TokenholderFactory;